import axios from 'axios';

export default async (cepCode) => {
  const uri = `https://viacep.com.br/ws/${cepCode}/json`;
  const { data } = await axios.get(uri);

  return {
    cep: data.cep,
    uf: data.uf,
    neighborhood: data.bairro,
    city: data.localidade,
    street: data.logradouro
  };
};
